import IconCRE from '../../assets/icon_cre.svg';
import IconClock from '../../assets/icon_clock.svg';
import IconCashFlow from '../../assets/icon_cashflow.svg';
import IconQuality from '../../assets/icon_quality.svg';
import IconGroundUp from '../../assets/icon_groundup.svg';
import IconTrackRecord from '../../assets/icon_trackrecord.svg';

import LocationLA from '../../assets/locations/img_location_la.jpg';

import people from './people';

export default {
  trackRecord: {
    title: 'Established Track Record',
    subTitle: 'We are proud to offer institutional quality deals to investors seeking to build wealth through commercial real estate. Our straightforward approach focuses on: offering smart diversification strategies, generating cash flow, and creating value in office, retail, and apartment buildings.',
    highlights: [
      { description: 'Paid Out To Our Investors' },
      { description: 'Property Value Financed' },
      { description: 'Registered Membership Base' },
    ],
  },
  ourStory: {
    heading: 'Our Founding Insights',
    body: [
      'Real estate has provided generations of investors with wealth. However, it has historically been reserved for those with specialized knowledge, the right connections and access to great amounts of capital. This has kept investing in commercial real estate out of reach for most - until a few years ago.',
      'While working in the wealth management sector, our CEO Jilliene Helman identified three key insights that separated the wealthiest clients from the rest. Her goal of sharing these insights would soon lead to the founding of RealtyMogul.',
    ],
    insights: [
      {
        icon: IconCRE,
        text: '1. The wealthiest clients were real estate investors',
      },
      {
        icon: IconClock,
        text: '2. Their income was not correlated to their time spent working',
      },
      {
        icon: IconCashFlow,
        text: '3. They focused on passive cash flow through real estate investments',
      },
    ],
  },
  exclusiveAccess: {
    heading: 'Exclusive Access to Institutional Quality Real Estate.',
    body: [
      'Our key insights have guided the RealtyMogul mission, pioneering ways to offer discerning investors access to thoroughly vetted commercial real estate opportunities.',
      'Our approach blends personalized service, proven business discipline and data-driven insights. This allows our members to diversify their portfolios with investments in individual properties and Real Estate Investment Trusts ("REITs").',
    ],
  },
  wellManaged: {
    heading: 'The search for well-managed, cash-flowing buildings.',
    body: [
      'Our mission is to help members invest with confidence. We only consider deals that pass our stringent due diligence process, and offer investors full visibility into every opportunity on our platform.',
    ],
    more: {
      to: '/knowledge-center/due-diligence',
      children: 'Learn More',
    },
    insights: [
      {
        icon: IconQuality,
        text: 'We look for well-leased properties or those with leases in hand.',
      },
      {
        icon: IconGroundUp,
        text: 'We do not invest in non-cash flowing investments such as ground-up construction or raw land.',
      },
      {
        icon: IconTrackRecord,
        text: 'We only work with select real estate partners with proven track records and experience managing assets.',
      },
    ],
  },
  access: {
    heading: 'Our investors deserve exceptional access and more',
    insights: [
      {
        heading: 'Our Beliefs',
        items: [
          'Discerning investors should have access to institutional-quality real estate opportunities.',
          'Investing in real estate offers a smart way to meet diversified portfolio goals.',
          'Investors should have access to dedicated service and licensed investment professionals.',
          'Human intelligence should validate technology.',
        ],
      },
      {
        heading: 'Our Promises',
        items: [
          'Prioritize investor protection with thorough processes, and tried-and-true business sense.',
          'Adhere to our strict fundamentals, including investing in properties that are well-leased or have other appealing attributes.',
          'Maintain a fully dedicated asset management team who supports each transaction through its lifecycle starting with the initial investment.',
          'Continue investing in data and technology to vet each deal.',
        ],
      },
    ],
  },
  leadership: {
    heading: 'Leadership Team',
    items: Object.keys(people).reduce((accum, index) => {
      return [
        ...accum,
        people[index],
      ];
    }, []),
  },
  locations: [
    {
      uuid: 'dff1ea88-db02-4450-a30d-87bb59288874',
      image: LocationLA,
      title: 'Los Angeles, CA',
      prefix: 'Realty Mogul Co, #603',
      address: '10573 W Pico Blvd',
      city: 'Los Angeles',
      state: 'CA',
      zip: '90064',
      phone: '(877) 977-2776',
    },
  ],
};
